import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import Field from '../Field'

const Description: React.FC = () => {
    const { description, productData } = useBrewDetailStore()
    const anyDescription = description || productData?.style?.description
    return (
        <Field gap='2' title='Description'>
            {anyDescription}
        </Field>
    )
}

export default Description
